module.exports = __webpack_public_path__ + "static/img/beta_bg_06.ff3693ab.svg";